import { ca } from '@cian/analytics';

export function trackErrorClick() {
  return ca('event', {
    action: 'bti_click',
    category: 'card',
    label: 'error',
    name: 'oldevent',
  });
}
